export default __webpack_public_path__ + "static/lab_kits-536ac7db2a1a721b62f330043e4989d0.mp4";